import React, {FunctionComponent} from 'react'
import {Garage, PartnerConfig} from "@App/types";
import {format, parseISO} from "date-fns";
import {de} from "date-fns/locale";
import useStore from "@App/store";
import {Mehrmarkencenter} from "@App/components/Home/ContentElements/PartnerIcons/Mehrmarkencenter";
import {BQC} from "@App/components/Home/ContentElements/PartnerIcons/BQC";
import {LiquiMoly} from "@App/components/Home/ContentElements/PartnerIcons/LiquiMoly";
import {AutoCrew} from "@App/components/Home/ContentElements/PartnerIcons/AutoCrew";

type GarageListMapMarkerProps = {
    garage: Garage
    open: boolean
    onClick: (garage: Garage) => void
    onToggle: (garage: Garage, open: boolean) => void
    lat: number
    lng: number
    partner: PartnerConfig
}

export const GarageListMapMarker: FunctionComponent<GarageListMapMarkerProps> = ({
                                                                                     garage,
                                                                                     open,
                                                                                     onClick,
                                                                                     onToggle,
                                                                                     partner
                                                                                 }: GarageListMapMarkerProps) => {
    const {highlightedGarageId} = useStore()


    return (
        <div className={"garageListMapMarker transition-all duration-400"}>
            <MapMarkerIcon garageId={garage.id}
                           price={garage.calculation && garage.calculation.estimated_price > 0 ? garage.calculation.estimated_price.toFixed(2).replace(".", ",").replace(',00', '') : ''}
                           date={garage.available_days && garage.available_days.length > 0 ? formatShortDate(garage.available_days[0].available_at) : 'n/a'}
                           clicked={open}
                           onClick={() => onToggle(garage, true)}
                           partner={partner}
                           highlighted={garage.id == highlightedGarageId}
            />
            { partner.showDateOnMapMarker && (
                <div className={`leaflet-popup-tip markertriangle ${garage.id == highlightedGarageId ? '!bg-primary-500' : ''}`}></div>
            )}
        </div>
    )
}


type MapMarkerIconProps = {
    garageId: string | number
    price: string
    date: string
    clicked: boolean
    onClick: () => void
    partner: PartnerConfig
    highlighted: boolean
}

export const MapMarkerIcon = ({garageId, price, date, clicked, onClick, partner, highlighted}: MapMarkerIconProps) => {

    return (
        <div onClick={onClick}
             className={`grid ${price.length > 0 ? "grid-cols-8" : ""} ${price.length == 0 && !partner.hasMapMarkerIcon ? "grid-cols-4" : ""} ${partner.hasMapMarkerIcon && partner.showDateOnMapMarker ? "grid-cols-6" : ''}  ${partner.hasMapMarkerIcon && !partner.showDateOnMapMarker ? "grid-cols-2" : ''}  ${clicked ? "lg:invisible" : ""} ${clicked || highlighted ? 'bg-primary-500 text-white ' : 'bg-white text-gray-900'} rounded-md w-max relative right-[38%] bottom-4 z-10`}>
            {partner.id == 18 && price.length == 0 && (
                <Mehrmarkencenter/>
            )}
            {partner.id == 21 && price.length == 0 && (
                <BQC/>
            )}
            {partner.id == 27 && price.length == 0 && (
                <LiquiMoly/>
            )}
            {partner.id == 29 && price.length == 0 && (
                <AutoCrew/>
            )}
            {price.length > 0 &&
                <div className={'col-span-4 p-1 text-xs leading-4 lg:text-base lg:leading-6 font-semibold border-r border-gray-200'}>
                    <span>€ {price}</span>
                </div>
            }
            {partner.showDateOnMapMarker && (
                <div className={'col-span-4 p-1 text-xs leading-4 lg:text-base lg:leading-6 font-normal min-w-[35px]'}>
                    <span>{date}</span>
                </div>
            )}

        </div>
    )
}

const formatShortDate = (date: Date | string): string => {
    if (typeof date === 'string') {
        date = parseISO(date)
    }
    return format(date, 'dd.MM.', {locale: de})
}
